import { useI18n } from 'locales'
import {
  GoogleSignUpButton,
  MicrosoftSignUpButton
} from 'components/sign_up_buttons'

import { useMutualAvailabilitySignupExperiment } from './hooks/use_mutual_availability_signup_experiment'
import {
  SignUpPanel,
  SignUpHeader,
  SignUpTitle,
  SignUpContent
} from './styles'

export const MutualAvailabilitySignUpHeader = () => {
  const { i18n } = useI18n()
  return (
    <SignUpHeader>
      <SignUpTitle>{i18n.t('booking.mutual_availability.sign_up_header')}</SignUpTitle>
    </SignUpHeader>
  )
}

export const MutualAvailabilitySignUpBox = () => {
  const { isSignUpWithGoogle, isSignUpWithMicrosoft } = useMutualAvailabilitySignupExperiment()

  if (isSignUpWithGoogle || isSignUpWithMicrosoft) {
    return (
      <SignUpPanel>
        <MutualAvailabilitySignUpHeader />
        <SignUpContent>
          {isSignUpWithGoogle && <GoogleSignUpButton />}
          {isSignUpWithMicrosoft && <MicrosoftSignUpButton />}
        </SignUpContent>
      </SignUpPanel>
    )
  }

  return null
}
